import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { Translate } from '@change-corgi/core/react/i18n';

// eslint-disable-next-line @change/sibling-module-imports
import { useShareButton } from 'src/app/shared/components/share/ShareButton/hooks/useShareButton';
import type { ShareAction as ShareActionType } from 'src/app/shared/hooks/share';

import { CHANNEL_META } from '../../constants';
import type { SupportedChannel } from '../../types';

type SharePetitionButtonProps = {
	buttonConfig: {
		channel: SupportedChannel;
		ShareAction: ShareActionType<SupportedChannel>['ShareAction'];
		label: TranslationKey;
		successLabel?: TranslationKey;
	};
};

export const SharePetitionButton: React.FC<SharePetitionButtonProps> = ({
	buttonConfig: { channel, ShareAction, label, successLabel },
}) => {
	const { data, actions } = useShareButton({ label, successLabel });
	const { Icon, className } = CHANNEL_META[channel];

	return (
		<ShareAction onAfterAction={actions.afterShare}>
			<button
				type="button"
				className="flex w-20 flex-col items-center gap-1 [@media(min-width:1204px)]:w-auto"
				data-testid={`share-petition-button-${channel}`}
				data-qa={`share-social-${channel}`}
			>
				<div className={cn('flex w-fit flex-col items-center justify-center rounded-full p-3', className)}>
					<Icon className="h-full w-full" svgClassName="w-full h-full" size={24} />
				</div>
				<Text aria-live="polite" as="span" className="text-size-body-small leading-5">
					<Translate value={data.buttonLabel} />
				</Text>
			</button>
		</ShareAction>
	);
};
